<ng-container>
  <ng-container *ngIf="!isExternal; else externalLink">
    <a (click)="clickAction()"
    routerLinkActive="{{ selectedClass }}"
    class="accordion__list-item-link">
      <ng-container *ngIf="isOpened; else extLinkClosed">
        <span>
          <mat-icon>{{ iconName }}</mat-icon>
        </span>
        <span class="nav-text">
          {{ text }}
        </span>
      </ng-container>
      <ng-template #extLinkClosed>
        <span matTooltip="{{ tooltipText }}">
          <mat-icon>{{ iconName }}</mat-icon>
        </span>
      </ng-template>
    </a>
  </ng-container>
  <ng-template #externalLink>
    <a (click)="clickAction()"
    target="_blank"
    class="accordion__list-item-link">
      <ng-container *ngIf="isOpened; else intLinkClosed">
        <span>
          <mat-icon>{{ iconName }}</mat-icon>
        </span>
        <span class="nav-text">
          {{ text }}
        </span>
      </ng-container>
      <ng-template #intLinkClosed>
        <span matTooltip="{{ tooltipText }}">
          <mat-icon>{{ iconName }}</mat-icon>
        </span>
      </ng-template>
    </a>
  </ng-template>
</ng-container>